import { FIELDS } from '@/pages/Inventory/constants';

const defaultFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    title: 'Qty Invoiced',
    cell: 'formatSeparator',
    field: 'quantityPulled',
    width: 100,
  },
  { 
    title: 'Return',
    field: 'qtyReturning',
    cell: 'formatNumberField',
    width: 100,
  },
  {
    title: 'Reason',
    field: 'rmaReasonId',
    cell: 'formatOptionsField',  
    width: 125,
  },
  {
    title: 'Comment',
    field: 'comments',
    cell: 'formatTextField',
    width: 150,
  },
  {
    title: 'Part Number',
    field: FIELDS.PART_NUMBER,
    width: 200,
  },
  {
    title: 'Description',
    field: FIELDS.DESCRIPTION,
    width: 300,
  },
  {
    title: 'Date Code',
    field: FIELDS.DATE_CODE,
    width: 150,
  },
  {
    title: 'Lot Code',
    field: FIELDS.LOT_CODE,
    width: 150,
  },
  {
    title: 'Revision',
    field: FIELDS.REVISION,
    width: 150,
  },
  {
    title: 'Condition',
    field: FIELDS.CONDITION_NAME,
    width: 150,
  },
  {
    title: 'COO',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    width: 150,
  },
  {
    title: 'Mfr',
    field: FIELDS.MFR,
    width: 150,
  },
  {
    title: ' ',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];

export default defaultFields;
